import { createContext, useCallback, useEffect, useState } from "react";
import { LOGGED_IN, USER_DATA } from "../const";

const AuthContext = createContext({});

const initialState = {
  user: [],
  isLogin: false,
};

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState(initialState);

  const getUser = useCallback(() => {
    const user_data = JSON.parse(localStorage.getItem(USER_DATA));
    const loged_in = JSON.parse(localStorage.getItem(LOGGED_IN));
    setAuth({
      user: user_data ? user_data : null,
      isLogin: loged_in,
    });
  }, [setAuth]);

  useEffect(() => {
    getUser();
  }, [getUser]);

  return (
    <AuthContext.Provider value={{ auth, setAuth }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
